module.exports = __webpack_public_path__ + "static/media/arrow_circle_right_icon.bc0b8739.svg";